<template>
<div class="row px-3">
	<div class="col-12 mt-4">
		<section-warehouse-body-filter
			:select="selectType"
			@change="changeWarehouseBy"
		/>
	</div>
	<div class="col-12 mt-4">
		<warehouse-select
			:add-button-visible="false"
			@input="setNewWarehouse"
			:saved-product-id="productId"
		/>
		<div class="d-flex justify-content-end mt-3">
			<button
				class="btn btn-primary"
				@click="isWarehouseFormVisible = true">
				<i class="material-icons">add</i>
				<span>{{ $t('Add Warehouse') }}</span>
			</button>
		</div>
	</div>
	<section-list-warehouse
		:product="product"
		:product-id="productId"
		:is-edit-product="isEditProduct"
	/>

	<!-- Modals -->
	<div class="modals">
		<warehouse-form
			:show="isWarehouseFormVisible"
			@set="setWarehouse"
			@close="isWarehouseFormVisible = false"
		/>
	</div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SectionWarehouseBodyFilter from '@/components/setting/Warehouse/section/body/Filter.vue';
import SectionListWarehouse from '@/components/products/new-inventory/section/ListWarehouse.vue';
import WarehouseSelect from '@/components/products/new-inventory/section/SectionWarehouseSelect.vue';
import WarehouseForm from '@/components/WarehouseForm.vue';
import productInventoryApi from '@/api/product-inventory';

const optionAllow = [
	{
		label: 'Allow',
		key: 1,
	},
	{
		label: 'Disallow',
		key: 0,
	},
];
export default {
	name: 'SectionMultiwarehouse',
	props: {
		product: {
			// type: Object,
		},
		selectedType: {
			type: String,
			default: () => 'nearest',
		},
		productId: {
			type: String,
			default: '',
		},
		isEditProduct: {
			type: Boolean,
			required: false,
		},
	},
	components: {
		SectionWarehouseBodyFilter,
		SectionListWarehouse,
		WarehouseSelect,
		WarehouseForm,
	},
	data() {
		return {
			isLoadingToogle: false,
			isWarehouseFormVisible: false,
			optionAllow,
			productInventory: [],
			selectType: this.selectedType,
		};
	},
	computed: {
		...mapGetters({
			warehouse: 'productWarehouse/warehouse',
			stock: 'productWarehouse/stock',
		}),
	},
	mounted() {
		// console.log(this.product);
	},
	methods: {
		...mapActions({
			addWarehouse: 'productWarehouse/addWarehouse',
		}),
		/**
		 * Change show warehouse by
		 *
		 * @param {String} type
		 * @this {String} select
		 */
		changeWarehouseBy(type) {
			this.selectType = type;
			this.$emit('change-type', type);
		},
		setNewWarehouse(warehouse) {
			if (!this.productId || this.productId === '') {
				this.$notify({
					group: 'app',
					type: 'danger',
					title: 'Add Product Inventory',
					text: 'You must set product name and product price first',
				});
				return;
			}
			const callback = (response) => {
				const productInventory = response.data;
				const warehouseLabel = warehouse.label;
				productInventory.warehouse_label = warehouseLabel;
				productInventory.warehouse_id = warehouse._id;
				this.productInventory = productInventory;
				this.addWarehouse(productInventory);
			};
			const err = (e) => {
				console.log(e);
			};
			const params = {
				product_id: this.productId,
				warehouse_id: warehouse._id,
			};
			productInventoryApi.create(params, callback, err);
		},
		setWarehouse(warehouse) {
			this.$bus.$emit('set-warehouse', warehouse);
		},
	},
};
</script>

<style></style>
